import React from 'react';
import { useSelector } from 'react-redux';

import { CMSContext, CMSNavigation } from '@swf/cms';
import { CacheControl } from '@swf/components/ResponseHeaders/ResponseHeaders';
import type { WidgetFC, WidgetInstanceProps } from '@swf/core/types/Widget';

import { cmsNavigationWidgetModel, useCmsNavigationWidget } from './model';

export type Props = WidgetInstanceProps;

const CMSNavigationWidget: WidgetFC<Props> = () => {
  const { widgetSelect } = useCmsNavigationWidget();
  const { menu, content = {}, depth = 1, cacheControl } = useSelector(widgetSelect.get);

  return menu ? (
    <CMSContext.Provider value={content}>
      {cacheControl && <CacheControl>{cacheControl}</CacheControl>}
      <CMSNavigation menu={menu} maxDepth={depth} />
    </CMSContext.Provider>
  ) : null;
};

CMSNavigationWidget.model = cmsNavigationWidgetModel;
export default CMSNavigationWidget;
